// Scheduling Points admin API (EMR-294).
//
// The generated client names embed the full route path, so this module is the
// single import site the admin surface talks to — and the seam the tests mock.
// Display metadata that has no home in the generated types lives here too,
// alongside the calls it describes (same shape as clinicsApi.ts).

import type { SchedulingPointCategory } from './api/types.gen';

// Human-readable aliases for the generated Scheduling Points client functions.
export {
  getClinicSchedulingPointsSchedulingPointsClinicsClinicIdGet as getClinicSchedulingPoints,
  updateClinicSchedulingPointsSchedulingPointsClinicsClinicIdPut as updateClinicSchedulingPoints,
  getAgencySchedulingPointsSchedulingPointsAgencyGet as getAgencySchedulingPoints,
  updateAgencySchedulingPointsSchedulingPointsAgencyPut as updateAgencySchedulingPoints,
  previewAgencyBlastRadiusSchedulingPointsAgencyBlastRadiusPost as previewAgencyBlastRadius,
  getSchedulingPointLoadSchedulingPointsLoadGet as getSchedulingPointLoad,
} from './api/sdk.gen';

// The order the grid reads in: the arc of a patient's care, assessment first
// and paperwork last, rather than the enum's declaration order. Keyed by the
// generated union so a new backend category fails to compile until it is
// placed deliberately.
export const CATEGORY_ORDER: Record<SchedulingPointCategory, number> = {
  oasis: 0,
  evaluation: 1,
  routine: 2,
  discharge: 3,
  supervisory: 4,
  care_plan: 5,
  order: 6,
  communication: 7,
};

export const categorySortIndex = (category: SchedulingPointCategory): number =>
  CATEGORY_ORDER[category] ?? Object.keys(CATEGORY_ORDER).length;
